// Category names are typed freely in the admin ("sabot orthopédique tendresse",
// "sandales orthopédiques TENDRESSE"), so show them in consistent sentence case.
export const formatCategoryName = (name = '') => {
  const lower = name.trim().toLowerCase().replace(/tendresse/g, 'Tendresse');
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};
